import React from 'react';
import { useSolplace } from '../context/SolplaceContext';
import './Controls.css';

const Controls = () => {
  const { 
    colors, 
    selectedColor, 
    wallet, 
    dailyPixels, 
    maxDailyPixels, 
    stats, 
    selectedPixel,
    placePixel,
    dispatch
  } = useSolplace();

  const handleColorSelect = (color) => {
    dispatch({ type: 'SET_SELECTED_COLOR', payload: color });
  };

  const handlePlacePixel = async () => {
    if (selectedPixel) {
      if (await placePixel(selectedPixel.x, selectedPixel.y)) {
        // Pixel was placed successfully
        dispatch({ type: 'SET_NOTIFICATION', payload: { 
          message: `Pixel placed at (${selectedPixel.x}, ${selectedPixel.y}) on the China map!`, 
          type: 'success' 
        }});
      } else {
        if (!wallet) {
          dispatch({ type: 'SET_NOTIFICATION', payload: { 
            message: 'Connect your wallet to place pixels', 
            type: 'warning' 
          }});
        } else if (dailyPixels >= maxDailyPixels) {
          dispatch({ type: 'SET_NOTIFICATION', payload: { 
            message: 'Daily pixel limit reached! Try again tomorrow.', 
            type: 'warning' 
          }});
        }
      }
    } else {
      dispatch({ type: 'SET_NOTIFICATION', payload: { 
        message: 'Select a position on the canvas', 
        type: 'warning' 
      }});
    }
  };

  return (
    <div className="controls">
      <div className="color-palette">
        {colors.map((color, index) => (
          <div
            key={color}
            className={`color-btn ${selectedColor === color ? 'active' : ''}`}
            style={{ backgroundColor: color }}
            title={color}
            onClick={() => handleColorSelect(color)}
          />
        ))}
      </div>
      
      <button 
        className="place-btn" 
        onClick={handlePlacePixel}
        disabled={!wallet || dailyPixels >= maxDailyPixels}
      >
        Place Pixel
      </button>
      
      <div className="stats">
        <div className="stat">
          <div className="stat-value">{stats.totalPixels}</div>
          <div>Total Pixels</div>
        </div>
        <div className="stat">
          <div className="stat-value">{stats.activeUsers}</div>
          <div>Active Users</div>
        </div>
        <div className="stat">
          <div className="stat-value">{stats.myPixels}</div>
          <div>My Pixels</div>
        </div>
        <div className="stat">
          <div className="stat-value">{maxDailyPixels - dailyPixels}</div>
          <div>Daily Left</div>
        </div>
      </div>
    </div>
  );
};

export default Controls;
